import ClientsInfiniteScrollList from './ClientInfiniteScrollList.container';

export default ClientsInfiniteScrollList;
